import { render } from "./EditSentenceDialog.vue?vue&type=template&id=07a05000&scoped=true"
import script from "./EditSentenceDialog.vue?vue&type=script&lang=js"
export * from "./EditSentenceDialog.vue?vue&type=script&lang=js"

import "./EditSentenceDialog.vue?vue&type=style&index=0&id=07a05000&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a05000"]])

export default __exports__